module.exports = __webpack_public_path__ + "img/logo2.b15e5319.png";